
export const BILLING_PERIODS_FETCH = 'moi/billing/BILLING_PERIOD_FETCH';
export const BILLING_PERIODS_RECEIVE = 'moi/billing/BILLING_PERIOD_RECEIVE';
export const SET_ACTIVE_BILLING_PERIOD = 'moi/billing/SET_ACTIVE_BILLING_PERIOD';
export const INVOICES_INITIALIZE = 'moi/billing/INVOICES_INITIALIZE';
export const INVOICES_FETCH = 'moi/billing/INVOICES_FETCH';
export const INVOICES_RECEIVE = 'moi/billing/INVOICES_RECEIVE';
export const INVOICES_RESET = 'moi/billing/INVOICES_RESET';
export const SET_DEFAULT_PAYMENT_METHOD = 'moi/billing/SET_DEFAULT_PAYMENT_METHOD';
export const SET_DEFAULT_PAYMENT_METHOD_FINISHED = 'moi/billing/SET_DEFAULT_PAYMENT_METHOD_FINISHED';
export const FETCH_ZUORA_SIGNATURE = 'moi/billing/FETCH_ZUORA_SIGNATURE';
export const RECEIVE_ZUORA_SIGNATURE = 'moi/billing/RECEIVE_ZUORA_SIGNATURE';
